module.exports = __webpack_public_path__ + "static/media/bonanza-logo-aangepast.7cefd047.png";